import StorageKeys from "../../const/StorageKeys";
import {
  DivisionsModel,
  SearchDivisionList,
} from "../../model/divisions/DivisionsModel";
import ApiService from "../../service/api/ApiService";
import ApiUrls from "../../service/api/ApiUrls";
import CacheStorage from "../../service/storage/CacheStorage";
import ShowToast from "../../widget/common/ui/Toast";

const DivisionsProvider = new (class DivisionsProvider {
  getDivisionListAPI = async (): Promise<Array<SearchDivisionList> | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) || "0";
    const url: string = `${ApiUrls.baseUrl}search/get_division_list`;
    let body: any = {
      account_id: accountId,
    };

    const response: any = await ApiService.postApi(url, body);
    console.log(response);
    if (response != null) {
      if (response["success"] === "1") {
        const divisionsModel: DivisionsModel = response;
        const searchDivisionList: Array<SearchDivisionList> =
          divisionsModel.result?.search_division_list!;

        return searchDivisionList;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default DivisionsProvider;
